import React, { useRef, useState } from "react";
import {
  Grid,
  Paper,
  IconButton,
  Typography,
  Dialog,
  DialogContent,
  Tooltip,
  Box,
} from "@mui/material";
import { SpinnerRoundFilled } from "spinners-react";
import "../../components/pages/dashboard/style/createInventory.css";
import CloseIcon from "@mui/icons-material/Close";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import EditIcon from "@material-ui/icons/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import Close from "@mui/icons-material/Close";
import NoPreview from "../../assests/images/no-preview.png";
import PreviewPdfmodel from "./previewComponent";
import { toast } from "react-toastify";

const IMAGE_EXTENSIONS = ["jpg", "jpeg", "png", "gif"];
const VIDEO_EXTENSIONS = ["mp4", "webm", "ogg", "mkv", "avi", "mov"];
const DOCUMENT_EXTENSIONS = ["doc", "docx", "pdf"];
const WORD_EXTENSIONS = ["doc", "docx"];
const MAX_FILE_SIZE = Number.MAX_SAFE_INTEGER;

const FileUploadGroup = ({
  onFilesChange,
  imageDetails,
  page,
  deleteExistingData,
  disabled,
  id = "fileInput",
  fileKind,
}) => {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [openPreview, setOpenPreview] = useState(false);
  const [previewSrc, setPreviewSrc] = useState("");
  const [isVideo, setIsVideo] = useState(false);
  const [pdfpreview, setPdfpreview] = useState(false);
  const [isDropzoneHover, setIsDropzoneHover] = useState(false);
  const userDetails = JSON.parse(window.sessionStorage.getItem("userDetails"));

  const [pdf, setpdf] = useState("");
  const [invoicePreviewOpen, setInvoicePreviewOpen] = useState(false);
  const [invoicePreviewUrl, setInvoicePreviewUrl] = useState("");
  const [invoicePreviewIsWord, setInvoicePreviewIsWord] = useState(false);
  const [wordHtmlContent, setWordHtmlContent] = useState("");
  const [wordPreviewLoading, setWordPreviewLoading] = useState(false);
  const fileInputRef = useRef(null);

  const canPreview =
    userDetails &&
    (userDetails.roleId == 2 || userDetails.roleId == 3 || userDetails.roleId == 6);

  const getFileExtension = (fileName = "") => {
    const cleanName = fileName.split("?")[0].split("#")[0];

    const lastDot = cleanName.lastIndexOf(".");

    if (lastDot === -1) return "";

    return cleanName.substring(lastDot + 1).toLowerCase();
  };

  const getUrlExtension = (url = "") => {
    return getFileExtension(url);
  };

  const isImageFile = (fileName) => {
    return IMAGE_EXTENSIONS.includes(getFileExtension(fileName));
  };

  const isPdfFile = (fileName) => {
    return DOCUMENT_EXTENSIONS.includes(getFileExtension(fileName));
  };

  const formatFileSize = (bytes) => {
    if (bytes === null || bytes === undefined) return "";

    if (bytes < 1024) {
      return `${bytes} B`;
    }

    if (bytes < 1024 * 1024) {
      return `${(bytes / 1024).toFixed(1)} KB`;
    }

    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  };

  const getExistingFileName = (item) => {
    if (!item) return "-";

    if (typeof item === "string") {
      const parts = item.split("/");
      const lastPart = parts[parts.length - 1];

      try {
        return decodeURIComponent(lastPart);
      } catch (error) {
        return lastPart;
      }
    }

    return item.fileName || item.name || "-";
  };

  const existingItems =
    (page === "view" || page === "Edit") && imageDetails
      ? imageDetails.filter(Boolean).map((item, index) => {
          const url =
            typeof item === "string"
              ? item
              : item.imageUrl || item.url || "";

          const extension = getUrlExtension(url);

          return {
            key: `existing-${index}`,
            isExisting: true,
            raw: item,
            url,
            name: getExistingFileName(item),
            sizeLabel: "",
            isImage: IMAGE_EXTENSIONS.includes(extension),
            isVideo: VIDEO_EXTENSIONS.includes(extension),
            isPdf: DOCUMENT_EXTENSIONS.includes(extension),
          };
        })
      : [];

  const newItems = selectedFiles.filter(Boolean).map((file, index) => {
    const extension = getFileExtension(file.name);

    return {
      key: `new-${index}`,
      isExisting: false,
      raw: file,
      url: URL.createObjectURL(file),
      name: file.name,
      sizeLabel: formatFileSize(file.size),
      isImage: IMAGE_EXTENSIONS.includes(extension),
      isPdf: DOCUMENT_EXTENSIONS.includes(extension),
    };
  });

  const allItems = [...existingItems, ...newItems];
  const hasUploadedFile = allItems.length > 0;
  const handlePreviewOpen = (src) => {
    if (!canPreview || !src) return;

    setPreviewSrc(src);
    setIsVideo(false);
    setOpenPreview(true);
  };

  const handlePreviewClose = () => {
    setPreviewSrc("");
    setIsVideo(false);
    setOpenPreview(false);
  };

  const handleOpenInvoicePreview = (url, isWord = false) => {
    if (!canPreview || !url) return;
    setInvoicePreviewUrl(url);
    setInvoicePreviewIsWord(isWord);
    setInvoicePreviewOpen(true);
  };

  const handleCloseInvoicePreview = () => {
    setInvoicePreviewUrl("");
    setInvoicePreviewIsWord(false);
    setWordHtmlContent("");
    setWordPreviewLoading(false);
    setInvoicePreviewOpen(false);
  };

  const loadMammothAndConvert = (fileSource) => {
    setWordPreviewLoading(true);
    setWordHtmlContent("");

    const loadMammoth = () =>
      new Promise((resolve, reject) => {
        if (window.mammoth) {
          resolve(window.mammoth);
          return;
        }
        const script = document.createElement("script");
        script.src =
          "https://cdnjs.cloudflare.com/ajax/libs/mammoth/1.6.0/mammoth.browser.min.js";
        script.onload = () => resolve(window.mammoth);
        script.onerror = () =>
          reject(new Error("Failed to load mammoth.js"));
        document.head.appendChild(script);
      });

    fetch(fileSource)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to fetch document");
        }

        return response.arrayBuffer();
      })
      .then((arrayBuffer) =>
        loadMammoth().then((mammoth) =>
          mammoth.convertToHtml({ arrayBuffer })
        )
      )
      .then((result) => {
        setWordHtmlContent(result.value);
        setWordPreviewLoading(false);
      })
      .catch(() => {
        setWordHtmlContent(
          "<p style='color:red'>Failed to preview document.</p>"
        );
        setWordPreviewLoading(false);
      });
  };
  const fileFormatDecide = (file) => {
    const splitvalues = file?.split("/");
    const lastValue = splitvalues[splitvalues.length - 1]?.split("-");
    return decodeURIComponent(lastValue[lastValue.length - 1]);
  };

  const documentOnPreview = (fileOrUrl) => {
    if (!canPreview || !fileOrUrl) return;

    let fileName = "";
    let previewSource = fileOrUrl;

    if (fileOrUrl instanceof File) {
      fileName = fileOrUrl.name;
      previewSource = URL.createObjectURL(fileOrUrl);
    } else {
      fileName = fileOrUrl;
    }

    const extension = getFileExtension(fileName);

    if (extension === "pdf") {
      handleOpenInvoicePreview(previewSource, false);
      return;
    }

    if (extension === "gif" || IMAGE_EXTENSIONS.includes(extension)) {
      handlePreviewOpen(previewSource);
      return;
    }

    if (WORD_EXTENSIONS.includes(extension)) {
      handleOpenInvoicePreview(previewSource, true);
      loadMammothAndConvert(previewSource);
      return;
    }
  };

  const openItemPreview = (item) => {
    if (!item || !canPreview) return;
    if (item.isPdf) {
      documentOnPreview(item.isExisting ? item.url : item.raw);
      return;
    }
    if (item.isImage) {
      if (item.isExisting) {
        handlePreviewOpen(item.url);
      } else {
        const blobUrl = URL.createObjectURL(item.raw);
        handlePreviewOpen(blobUrl);
      }

      return;
    }
  };

  const validateFile = (file) => {
    if (!file) return false;

    const extension = getFileExtension(file.name);
    const allowedExtensions = [
      ...IMAGE_EXTENSIONS,
      ...DOCUMENT_EXTENSIONS,
    ];

    if (!allowedExtensions.includes(extension)) {
      toast.error(
        "Invalid file type! Allowed formats: JPG, JPEG, PNG, GIF, PDF, DOC, DOCX.",
        {
          autoClose: 3000,
          position: toast.POSITION.BOTTOM_CENTER,
        }
      );
      return false;
    }

    if (file.size > MAX_FILE_SIZE) {
      toast.error("File is too large to upload.", {
        autoClose: 3000,
        position: toast.POSITION.BOTTOM_CENTER,
      });

      return false;
    }

    return true;
  };

  const processFile = (file) => {
    if (!file) return;

    if (!validateFile(file)) {
      return;
    }

    const formData = new FormData();
    formData.set("charitableEventId", 20);
    formData.append("uploadFiles", file);
    setSelectedFiles([file]);
    onFilesChange(formData, [file]);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const handleFileChange = (event) => {
    if (disabled) return;

    const files = event.target.files;

    if (!files || files.length === 0) {
      return;
    }
    const selectedFile = files[0];

    processFile(selectedFile);
  };
  const handleReplace = (event) => {
    event.preventDefault();
    event.stopPropagation();

    if (disabled) return;
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();

    if (disabled) return;

    const files = event.dataTransfer?.files;

    if (!files || files.length === 0) {
      return;
    }
    processFile(files[0]);
  };

  const handleDownload = (file) => {
    const blobUrl = URL.createObjectURL(file);
    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = file.name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(blobUrl);
  };

  const handleDownloadUrl = (fileUrl) => {
    const link = document.createElement("a");
    link.href = fileUrl;
    link.download = fileFormatDecide(fileUrl) || "download";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDelete = (fileToDelete) => {
    const remaining = selectedFiles.filter(
      (file) => file !== fileToDelete
    );

    setSelectedFiles(remaining);
    onFilesChange({}, remaining);
  };
  const handleclose = () => setPdfpreview(false);

  const acceptAttr =
    "image/jpeg,image/jpg,image/png,image/gif,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,.jpg,.jpeg,.png,.gif,.pdf,.doc,.docx";

  return (
    <Grid container spacing={2}>
      {!hasUploadedFile && page !== "view" && (
        <Grid item xs={12}>
          <div
            className="ai-dropzone"
            onDragOver={(event) => event.preventDefault()}
            onDrop={handleDrop}
            onMouseEnter={() =>
              !disabled && setIsDropzoneHover(true)
            }
            onMouseLeave={() => setIsDropzoneHover(false)}
            style={{
              opacity: disabled ? 0.6 : 1,
              cursor: disabled ? "default" : "pointer",
            }}
          >
            <input
              ref={fileInputRef}
              type="file"
              id={id}
              onChange={handleFileChange}
              accept={acceptAttr}
              style={{ display: "none" }}
              disabled={disabled}
            />
            <label
              htmlFor={id}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                cursor: disabled ? "default" : "pointer",
              }}
            >
              <InsertDriveFileOutlinedIcon
                style={{
                  fontSize: 26,
                  color:
                    isDropzoneHover && !disabled
                      ? "#CEA05F"
                      : "#bdbdbd",
                }}
              />
              <Typography className="ai-dropzone__title">
                Click to upload or drag &amp; drop
              </Typography>
              <Typography className="ai-dropzone__hint">
                JPG, PNG, JPEG, PDF, DOC, DOCX, GIF
              </Typography>
            </label>
          </div>
        </Grid>
      )}
      {hasUploadedFile && page !== "view" && (
        <input
          ref={fileInputRef}
          type="file"
          onChange={handleFileChange}
          accept={acceptAttr}
          style={{ display: "none" }}
          disabled={disabled}
        />
      )}

      <Grid item xs={12} style={{ margin: 0 }}>
        {allItems.map((item) => (
          <Paper
            key={item.key}
            elevation={0}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 5,
              padding: "8px 12px",
              border: "1px solid #ececec",
              borderRadius: 8,
              marginBottom: 8,
            }}
          >
            <div
              style={{
                width: 44,
                height: 44,
                borderRadius: 6,
                overflow: "hidden",
                flexShrink: 0,
                background: "#f5f5f5",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {item.isImage ? (
                <img
                  src={item.url}
                  alt=""
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              ) : (
                <img
                  src={NoPreview}
                  alt=""
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              )}
            </div>
            <div
              style={{
                flex: 1,
                minWidth: 0,
              }}
            >
              <Typography
                className="ai-uploads__file-chip-name"
                onClick={() => openItemPreview(item)}
              >
                {item.name}
              </Typography>
              {item.sizeLabel && (
                <Typography className="ai-uploads__file-chip-size">{item.sizeLabel}</Typography>
              )}
            </div>
            
            {canPreview && (
              <Tooltip title="View">
                <IconButton size="small" onClick={() => openItemPreview(item)}>
                  <VisibilityIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
          <div>
            {!disabled && page !== "view" && (
              <Tooltip title="Replace">
                <IconButton
                  size="small"
                  onClick={handleReplace}
                >
                  <EditIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
          </div>
          <div>
            <Tooltip title="Download">
              <IconButton
                size="small"
                onClick={(e) => {
                  e.preventDefault();
                  item.isExisting ? handleDownloadUrl(item.url) : handleDownload(item.raw);
                }}
              >
                <CloudDownloadIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </div>
          <div>
            {!disabled && (
              <Tooltip title="Remove">
                <IconButton
                  size="small"
                  onClick={(e) => {
                    e.preventDefault();
                    item.isExisting
                      ? deleteExistingData && deleteExistingData(item.raw)
                      : handleDelete(item.raw);
                  }}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
          </div>
          </Paper>
        ))}
      </Grid>

      {/* Image / Video preview dialog */}
      <Dialog open={openPreview} onClose={handlePreviewClose} maxWidth="md" fullWidth>
        <DialogContent>
          <Typography className="mb-20 mt-10 md-bold" sx={{ fontWeight: "500 !important", fontSize: "18px !important" }}>
            Preview
          </Typography>
          <IconButton edge="end" color="inherit" onClick={handlePreviewClose} aria-label="close" sx={{ position: "absolute", top: 6, right: 30 }}>
            <Close />
          </IconButton>
          {isVideo ? (
            <video src={previewSrc} style={{ width: "100%" }} controls />
          ) : (
            <img src={previewSrc} alt="Preview" style={{ width: "100%" }} />
          )}
        </DialogContent>
      </Dialog>

      {/* Document (PDF/Word) preview dialog */}
      <Dialog open={invoicePreviewOpen} onClose={handleCloseInvoicePreview} maxWidth="md" fullWidth>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", px: 3, pt: 2, pb: 0 }}>
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            Document Preview
          </Typography>
          <IconButton onClick={handleCloseInvoicePreview}>
            <Close />
          </IconButton>
        </Box>
        <DialogContent>
          {invoicePreviewUrl &&
            (() => {
              const isBlob = invoicePreviewUrl.startsWith("blob:");
              const isPdf = invoicePreviewUrl.toLowerCase().includes(".pdf");
              const isDoc = invoicePreviewUrl.toLowerCase().includes(".doc");
              const isDocx = invoicePreviewUrl.toLowerCase().includes(".docx");

              if (invoicePreviewIsWord) {
                if (wordPreviewLoading) {
                  return (
                    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: 300 }}>
                      <SpinnerRoundFilled size={50} color="#CEA05F" />
                    </Box>
                  );
                }
                return (
                  <Box
                    sx={{
                      height: "500px",
                      overflowY: "auto",
                      border: "1px solid #e0e0e0",
                      borderRadius: "5px",
                      padding: "24px",
                      background: "#fff",
                      fontSize: "14px",
                      lineHeight: 1.7,
                      color: "#000",
                    }}
                    dangerouslySetInnerHTML={{ __html: wordHtmlContent }}
                  />
                );
              }

              if (isBlob || isPdf || isDoc || isDocx) {
                const iframeSrc = isBlob
                  ? invoicePreviewUrl
                  : `https://docs.google.com/viewer?url=${encodeURIComponent(invoicePreviewUrl)}&embedded=true`;
                return (
                  <iframe src={iframeSrc} width="100%" height="500px" title="document-preview" style={{ border: "none", borderRadius: "5px" }} />
                );
              }
              return <img src={invoicePreviewUrl} alt="Preview" style={{ width: "100%", borderRadius: "5px" }} />;
            })()}
        </DialogContent>
      </Dialog>

      {pdfpreview ? (
        <PreviewPdfmodel url={pdf} handleClose={handleclose} open={pdfpreview} title={id} />
      ) : null}
    </Grid>
  );
};

export default FileUploadGroup;